import { faUsersCog, faDesktop, faUserFriends, faMicrophoneAlt, faHandsHelping } from "@fortawesome/free-solid-svg-icons";

const departmentsData = [
  {
    name: "Marketing",
    description: "O departamento de Marketing é responsável pela divulgação de todos os eventos e atividades desenvolvidas, manutenção das redes sociais e site do NEEQ, desenvolvimento do vestuário de curso e cobertura fotográfica de todos os eventos.",
    coordinators: "Simão Andrade e Lara Pereira",
    icon: faDesktop,
    delay: "0.4s"
  },
  {
    name: "Recreativo",
    description: "O departamento Recreativo é responsável pela organização de eventos de componente festiva (jantares de curso, churrascos, gala, etc), dinamização de atividades de cariz cultural (como karaoke, sessões de cinema, playlists, etc) e promoção da atividade física (por torneios, corridas, entre outros).",
    coordinators: "Margarida Figueira, João Rocha e Inês Laranjeira",
    icon: faMicrophoneAlt,
    delay: "0.4s"
  },
  {
    name: "Pedagógico",
    description: "O departamento Pedagógico é responsável pela dinamização do ChemBonding, palestras/mesas redondas e workshops de cariz didática, organização da feira de sebentas e manutenção do Banco de Apontamentos e Erasmus.",
    coordinators: "Telmo Pereira e Mariana Cardoso",
    icon: faUserFriends,
    delay: "0.2s"
  },
  {
    name: "Sustentabilidade e Ação Social",
    description: "O departamento de sustentabilidade e ação social é responsável pela organização de ações de voluntariado (e manutenção do grupo de voluntariado) e recolhas solidárias, realização de workshops e palestras de cariz social/sustentável e dinamização de momentos de sensibilização a diferentes temas.",
    coordinators: "Gonçalo Pinheiro e Laura Cruz",
    icon: faHandsHelping,
    delay: "0.4s"
  },
  {
    name: "BET",
    description: "O BET, Building Engineers of Tomorrow, é um evento anual do NEEQ no qual, ao longo de múltiplos dias, é proposto um case study às equipas inscritas, para além da visita a uma empresa, workshops de soft e hard skills e palestra.",
    coordinators: "Gustavo Teófilo, Pedro Luca, Francisca Tomé, Beatriz Teixeira, Luísa Cruz e Matilde Correia",
    icon: faUsersCog,
    delay: "0.2s"
  },
]

export default departmentsData;
